import { enhancedApiClient, isSuccessResponse, isErrorResponse, ApiResponse } from "../../services/enhancedApiClient";
import { Site, SiteFormData } from "./site";

class SiteService {
  // Fetch all sites with pagination and filtering
  async getSites(params?: {
    page?: number;
    limit?: number;
    search?: string;
    status?: boolean;
    customerId?: string;
    siteId?: string;
  }): Promise<ApiResponse<{sites: Site[]; pagination: any}>> {
    // Convert camelCase to snake_case for API
    const apiParams: any = { ...params };
    if (params?.customerId) {
      apiParams.customer_id = params.customerId;
      delete apiParams.customerId;
    }
    if (params?.siteId) {
      apiParams.site_id = params.siteId;
      delete apiParams.siteId;
    }
    
    const response = await enhancedApiClient.get("/sites", { 
      params: apiParams,
      context: "Fetch Sites",
      component: "SiteService"
    });
    
    if (isSuccessResponse(response)) {
      console.log("Fetched sites Data from siteservice:", response.data);
      return response;
    }
    
    // Error response is already handled by the enhanced API client
    return response;
  }

  // Create a new site
  async createSite(siteData: SiteFormData): Promise<ApiResponse<Site>> {
    console.log("Payload sent:", siteData);
    const response = await enhancedApiClient.post("/sites", siteData, {
      context: "Create Site",
      component: "SiteService"
    });
    
    if (isSuccessResponse(response)) {
      return response;
    }
    
    return response;
  }

  // Update an existing site
  async updateSite(
    siteId: string,
    siteData: Partial<SiteFormData>
  ): Promise<ApiResponse<Site>> {
    const response = await enhancedApiClient.put(`/sites/${siteId}`, siteData, {
      context: "Update Site",
      component: "SiteService"
    });
    
    if (isSuccessResponse(response)) {
      return response;
    }
    
    return response;
  }

  // Delete a site
  async deleteSite(siteId: string): Promise<ApiResponse<{ message: string }>> {
    const response = await enhancedApiClient.delete(`/sites/${siteId}`, {
      context: "Delete Site",
      component: "SiteService"
    });
    
    if (isSuccessResponse(response)) {
      return response;
    }
    
    return response;
  }
  
  // Get site by type
  async getSitesByType(type: string): Promise<ApiResponse<Site[]>> {
    const response = await enhancedApiClient.get("/sites", { 
      params: { site_type: type },
      context: "Get Sites By Type",
      component: "SiteService"
    });
    
    if (isSuccessResponse(response)) {
      return response;
    }
    
    return response;
  }

  // Search sites
  async searchSites(
    searchTerm: string
  ): Promise<ApiResponse<Site[]>> {
    const response = await enhancedApiClient.get(`/sites?search=${searchTerm}`, {
      context: "Search Sites",
      component: "SiteService"
    });
    
    if (isSuccessResponse(response)) {
      return response;
    }
    
    return response;
  }

  // Get site statistics
  async getSiteStatistics(): Promise<ApiResponse<any>> {
    const response = await enhancedApiClient.get("/sites/stats", {
      context: "Get Site Statistics",
      component: "SiteService"
    });
    
    if (isSuccessResponse(response)) {
      return response;
    }
    
    return response;
  }

  async getSiteById(
    siteId: string
  ): Promise<ApiResponse<Site>> {
    const response = await enhancedApiClient.get(`/sites/${siteId}`, {
      context: "Get Site By ID",
      component: "SiteService"
    });
    
    if (isSuccessResponse(response)) {
      return response;
    }
    
    return response;
  }
}

export const siteService = new SiteService();